export const LEVEL_FIELD_TYPE = {
  PREREQUISITES: 'PREREQUISITES',
  TYPICAL_LEARNER: 'TYPICAL_LEARNER',
};
